import { persistOptionSelections as persistConfiguratorOptionSelections } from "./configurator/persistence";
import { persistOptionSelections as persistGridOptionSelections } from "./product-grid2/persistence";

export const middleware = [
    persistConfiguratorOptionSelections,
    persistGridOptionSelections,
] as const;
